<template>
    <div>
        <button
            v-show="showProcessingPayemntButton"
            type="button"
            id="paymentbutton"
            class="btn amazon-processing-button"
            :disabled="showSpinner"
            @click="onClickErrorRedirect()"
        >
            <div :class="['spinner', 'white-spinner', {'spinner-visible': showSpinner}]">
                <span></span>
                <span></span>
                <span></span>
            </div>

            <template v-if="!showSpinner">
                {{ payButtonText }}
            </template>
        </button>
        <div :class="containerCSSClass" :id="containerID" v-show="!showLoadingButton"></div>
        <div :class="fakebuttonCSSClass" v-show="showLoadingButton">{{ resources.processingPayment }}</div>
    </div>
</template>

<script src="./amazonpay-payment-button.js"></script>
